// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* emom-timer.component.scss */
.container {
  display: flex;
  padding-left: 1.5em;
  padding-right: 1.5em;
  justify-content: center;
  align-items: center;
}
.container .form-header .title {
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
}
.container .timer-form {
  height: 70vh;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-around;
  background: var(--ion-color-secondary);
}
.container .timer-form .description {
  text-align: center;
  margin-bottom: 10px;
}
.container .timer-form .form-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.container .timer-form .form-row ion-label {
  min-width: 75px;
}
.container .timer-form .form-row ion-label:first-child {
  text-align: end;
}
.container .timer-form .form-row ion-label:last-child {
  text-align: start;
}
.container .timer-form ion-input {
  height: auto;
  max-width: 56px;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  --padding-start: 0;
  border-radius: 10px;
  margin-left: 20px;
  margin-right: 20px;
  border: 1px solid var(--ion-color-primary);
}

.form-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.form-header ion-icon {
  font-size: 2rem;
}

ion-card {
  margin-top: 10px;
}

.timer-container {
  padding: 1em;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: auto;
}

:host ::ng-deep app-circular-progress .progress-container {
  width: 300px;
  height: 300px;
}

.progress-container {
  position: relative;
  width: 100%;
}

.timer-display {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 5em;
  font-weight: bold;
  z-index: 1; /* Ensure the text is above the progress bar */
  color: var(--ion-color-primary);
}

.round-info {
  text-align: center;
  margin-top: 10px;
  font-size: 2rem;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/components/emom-timer/emom-timer.component.scss"],"names":[],"mappings":"AAAA,8BAAA;AAEA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;AAEI;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;AAAR;AAGI;EACI,YAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,6BAAA;EACA,sCAAA;AADR;AAGQ;EACI,kBAAA;EACA,mBAAA;AADZ;AAIQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAFZ;AAIY;EACI,eAAA;AAFhB;AAIgB;EACI,eAAA;AAFpB;AAKgB;EACI,iBAAA;AAHpB;AAQQ;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;AANZ;;AAWA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AARJ;AAUI;EACI,eAAA;AARR;;AAYA;EACI,gBAAA;AATJ;;AAYA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;AATJ;;AAaI;EACI,YAAA;EACA,aAAA;AAVR;;AAcA;EACI,kBAAA;EACA,WAAA;AAXJ;;AAgBA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;EACA,iBAAA;EAEA,UAAA,EAAA,8CAAA;EACA,+BAAA;AAdJ;;AAiBA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAdJ","sourcesContent":["/* emom-timer.component.scss */\n\n.container {\n    display: flex;\n    padding-left: 1.5em;\n    padding-right: 1.5em;\n    justify-content: center;\n    align-items: center;\n\n    .form-header .title {\n        text-align: center;\n        font-size: 2rem;\n        font-weight: bold;\n    }\n\n    .timer-form {\n        height: 70vh;\n        display: flex;\n        width: 100%;\n        flex-direction: column;\n        justify-content: space-around;\n        background: var(--ion-color-secondary);\n\n        .description {\n            text-align: center;\n            margin-bottom: 10px;\n        }\n\n        .form-row {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            margin-top: 20px;\n\n            ion-label {\n                min-width: 75px;\n\n                &:first-child {\n                    text-align: end;\n                }\n\n                &:last-child {\n                    text-align: start;\n                }\n            }\n        }\n\n        ion-input {\n            height: auto;\n            max-width: 56px;\n            text-align: center;\n            font-size: 1.5rem;\n            font-weight: bold;\n            --padding-start: 0;\n            border-radius: 10px;\n            margin-left: 20px;\n            margin-right: 20px;\n            border: 1px solid var(--ion-color-primary);\n        }\n    }\n}\n\n.form-header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n\n    ion-icon {\n        font-size: 2rem;\n    }\n}\n\nion-card {\n    margin-top: 10px;\n}\n\n.timer-container {\n    padding: 1em;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-items: center;\n    height: auto;\n}\n\n:host ::ng-deep {\n    app-circular-progress .progress-container {\n        width: 300px;\n        height: 300px;\n    }\n}\n\n.progress-container {\n    position: relative;\n    width: 100%;\n    // height: 0;\n    // padding-bottom: 100%; /* Maintain a 1:1 aspect ratio for the circular progress */\n}\n\n.timer-display {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 5em;\n    font-weight: bold;\n    // color: var(--ion-text-color);\n    z-index: 1; /* Ensure the text is above the progress bar */\n    color: var(--ion-color-primary);\n}\n\n.round-info {\n    text-align: center;\n    margin-top: 10px;\n    font-size: 2rem;\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
